export default __webpack_public_path__ + "static/media/proj14.f0acc174.png";